import React, { useEffect, useState } from "react";
import { AlternativeImage, ImageCheckType } from "SuperAdmin/Config/ImageType";
import { checkImageUrl } from "SuperAdmin/Utils/CheckImageUrl";

const ImageCheck = ({ url, classname, type, alt }) => {
  const [image, setImage] = useState(
    type == ImageCheckType.FACULTY_AVATAR
      ? AlternativeImage.FACULTY_AVATAR
      : type == ImageCheckType.INSTITUTION_SEAL
      ? AlternativeImage.INSTITUTION_SEAL
      : AlternativeImage.INSTITUTION_LOGO
  );
  useEffect(() => {
    if (url == null) {
      setImage(AlternativeImage[`${type}`]);
    } else checkImageUrl(url, setImage, type);
  }, [url]);
  return <img src={image} alt={alt} className={classname} />;
};

export default ImageCheck;
